import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import UIkit from 'uikit'
import UIkitIcons from 'uikit/dist/js/uikit-icons'

export default function Icon({ className, name }: props) {
  UIkit.use(UIkitIcons)

  return (
    <span uk-icon={`icon: ${name}`} className={classNames('Icon', className)} aria-hidden />
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js